import i18next from 'i18next';
const lang = {
    elements_logo: 'img/games/elements/logo.png',
    elements_button_first_game: 'Tek Oyuncu',
    elements_button_second_game: 'İki Oyuncu',
    elements_button_settings: 'Ayarlar',
    elements_button_save: 'Kaydet',
    elements_button_back: 'Geri',
    elements_title_first_number: '1. Sayı',
    elements_title_second_number: '2. Sayı',
    elements_description_first_multiplier: '1. Oyuncu',
    elements_description_second_multiplier: '2. Oyuncu',
    elements_description_gamer: '{{gamer}}. Oyuncu',
    elements_title_time: 'Zaman Seçiniz',
    elements_title_second: 'Saniye',
    elements_title_point: 'Puan',
    elements_title_record: 'Rekor',
    elements_title_winning: 'Kazanan',
    elements_description_record: 'Tebrikler yeni bir rekora sahipsin.',
    elements_description_landscape: 'Lütfen cihazınızı yatay modda kullanınız!',
    elements_result_draw: 'Berabere',
    elements_info_wait: '{{time}} saniye sakin ol',
    elements_info_continue: 'Çözmeye devam edebilirsin',
    elements_info_error: 'Hata yaptın',
    elements_info_notification_1: 'Tebrikler',
    elements_info_notification_2: 'İyi Gidiyorsun',
    elements_info_notification_3: 'Harikasın',
    elements_info_notification_4: 'Süpersin',
}


// i18next.addResourceBundle('tr', 'translation', lang, true, true);
export default lang;
